import React from 'react'
import { FormattedMessage, injectIntl, Link, FormattedHTMLMessage } from "gatsby-plugin-intl"
import Fade from 'react-reveal/Fade';

import terrestre from '../images/icon-nb-terrestre.svg'
import aerea from '../images/icon-nb-aereo.svg'
import maritima from '../images/icon-nb-maritimo.svg'
import almacen from '../images/icon-nb-almacen.svg'
import aduana from '../images/icon-nb-aduanal.svg'

const CarteraServicios = () => {
	return (
		<section className="cartera-servicios">
			<div className="cont">
				<div className="titulo text-center text-white">
					<h2><FormattedMessage id="servicios.titulo" /></h2>
				</div>
				<ul>
					<li className="item">
						<Fade bottom>
							<figure>
								<div className="icon">
									<img src={almacen} alt=""/>
								</div>
								<figcaption>
									<h3><FormattedHTMLMessage id="servicios.almacen" /></h3>
								</figcaption>
								<Link to="/servicios/almacen-distribucion" className="btn btn-solid rojo"><FormattedMessage id="conoce_mas" /></Link>
							</figure>
						</Fade>
					</li>
					<li className="item">
						<Fade bottom>
							<figure>
								<div className="icon">
									<img src={terrestre} alt=""/>
								</div>
								<figcaption>
									<h3><FormattedHTMLMessage id="servicios.terrestre" /></h3>
								</figcaption>
								<Link to="/servicios/transportacion-terrestre" className="btn btn-solid rojo"><FormattedMessage id="conoce_mas" /></Link>
							</figure>
						</Fade>
					</li>
					<li className="item">
						<Fade bottom>
							<figure>
								<div className="icon">
									<img src={maritima} alt=""/>
								</div>
								<figcaption>
									<h3><FormattedHTMLMessage id="servicios.maritima" /></h3>
								</figcaption>
								<Link to="/servicios/transportacion-maritima" className="btn btn-solid rojo"><FormattedMessage id="conoce_mas" /></Link>
							</figure>
						</Fade>
					</li>
					<li className="item">
						<Fade bottom>
							<figure>
								<div className="icon">
									<img src={aerea} alt=""/>
								</div>
								<figcaption>
									<h3><FormattedHTMLMessage id="servicios.aerea" /></h3>
								</figcaption>
								<Link to="/servicios/transportacion-aerea" className="btn btn-solid rojo"><FormattedMessage id="conoce_mas" /></Link>
							</figure>
						</Fade>
					</li>
					<li className="item">
						<Fade bottom>
							<figure>
								<div className="icon">
									<img src={aduana} alt=""/>
								</div>
								<figcaption>
									<h3><FormattedHTMLMessage id="servicios.agencia" /></h3>
								</figcaption>
								<Link to="/servicios/agencia-aduanal" className="btn btn-solid rojo"><FormattedMessage id="conoce_mas" /></Link>
							</figure>
						</Fade>
					</li>
				</ul>
			</div>
		</section>
	)
}

export default injectIntl(CarteraServicios)
